import { Box } from "@mui/material";
import GradientSweep from "./GradientSweep";

// The page-wide backdrop: one fixed, non-interactive layer behind everything.
// Mounted once in App.js ahead of the routed pages. z-index -1 with no stacking
// ancestor puts it in the root stacking context, so sections that tuck their own
// decoration behind their neighbours at z-index -1 (Neram's white blob) still
// paint above it, being later in the DOM. `pointer-events: none` also keeps it
// out of `elementFromPoint`, which the Navbar's contrast sampler relies on.
const AppBackground = () => (
  <Box
    aria-hidden="true"
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: -1,
      pointerEvents: "none",
      contain: "strict",
    }}
  >
    <GradientSweep />
  </Box>
);

export default AppBackground;
